module.exports = __webpack_public_path__ + "static/img/packaged-liquid-biofuel_256.1de5343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-liquid-biofuel_256.png
// module id = e2QL
// module chunks = 0